'use client';

import { Accordion, AccordionContent, AccordionItem } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ArrowDownIcon, ArrowUpIcon, PlusIcon } from 'lucide-react';
import { useState } from 'react';

const faq = [
  {
    question: 'Is Kawkb a registered company?',
    answer:
      'Yes, Kawkb is a registered LLC, operating with full compliance to local regulations, ensuring a secure and reliable hosting experience.',
  },
  {
    question: 'Can I list a property that is outside a gated community or compound?',
    answer:
      "No, Kawkb focuses exclusively on hosting units within gated communities. This ensures safety, security, and consistency, aligning with our target audience's preferences.",
  },
  {
    question: 'What is the minimum and maximum stay duration on Kawkb?',
    answer:
      'Kawkb focuses on short stays, ranging from one day to six months, allowing flexibility for both hosts and guests.',
  },
  {
    question: 'Can I see guest verification details before accepting a booking?',
    answer:
      'Yes, you can view key verification details on the guest profile within the Control Hub.',
  },
  {
    question: 'Are there any community guidelines that guests must follow?',
    answer:
      'Yes, all guests must agree to abide by our community guidelines and your specific house rules before booking. Violations may result in penalties or banning from the platform.',
  },
  {
    question: 'Are guests notified of my house rules before booking?',
    answer:
      'Yes, guests must acknowledge and accept your house rules as part of the booking process.',
  },
  {
    question: 'What kind of support can I expect from Kawkb?',
    answer:
      'Our local support team is available to assist with guest inquiries, booking issues, and property management guidance whenever you need it.',
  },
  {
    question: 'How can I reach the support team?',
    answer: 'You can call us directly through the Control Hub or call us now on +201021514433.',
  },
  {
    question: 'What can I manage through the Control Hub?',
    answer:
      'You can update availability, set pricing, track payments, and manage guest interactions – all from one place.',
  },
  {
    question: 'Do I need to furnish my property before listing on Kawkb?',
    answer:
      'Yes, all listed units must be fully furnished and include essential appliances to ensure a comfortable guest experience.',
  },
  {
    question: 'Where is property management available?',
    answer:
      'Our professional management services are currently offered in select areas and for specific unit types. Check the Control Hub for availability in your region.',
  },
  {
    question: 'What services are included in property management?',
    answer:
      'We handle guest check-ins, cleaning, maintenance coordination, and listing optimization.',
  },
  {
    question: 'Can I change my payout schedule?',
    answer: 'Currently, payouts are processed weekly to ensure consistency and faster transfers.',
  },
  {
    question: 'How does the Protection Plan work?',
    answer:
      'You can either request a security deposit from guests or subscribe to our damage protection plan, covering accidental damages during stays.',
  },
  {
    question: 'What does the protection plan cover?',
    answer:
      'It covers accidental damages like broken furniture or stained upholstery, depending on the plan you choose.',
  },
  {
    question: 'How can I maximize the occupancy rate of my property on Kawkb?',
    answer:
      'To boost your occupancy, we recommend maintaining competitive pricing, keeping your listing updated, and leveraging our professional photo shoot service to enhance visual appeal. Our team also provides tips on optimizing your listing for better visibility.',
  },
  {
    question: 'What is the average occupancy rate for properties listed on Kawkb?',
    answer:
      'Occupancy rates vary based on location, season, and property type. However, properties in popular gated communities with professional photos and competitive pricing tend to have higher occupancy rates.',
  },
];

const FAQ07 = () => {
  const [showMore, setShowMore] = useState(false);
  const toggleFagLength = () => {
    setShowMore(!showMore);
  };
  return (
    <div className="flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-4xl">
        <h2 className="text-4xl md:text-5xl !leading-[1.15] font-black tracking-tighter">
          Frequently Asked Questions
        </h2>

        <Accordion type="single" collapsible className="mt-8 space-y-4" defaultValue="question-0">
          {faq.slice(0, showMore ? faq.length : 3).map(({ question, answer }, index) => (
            <AccordionItem
              key={question}
              value={`question-${index}`}
              className="bg-accent py-1 px-4 rounded-xl border-none"
            >
              <AccordionPrimitive.Header className="flex">
                <AccordionPrimitive.Trigger
                  className={cn(
                    'flex flex-1 items-center justify-between py-4 font-semibold tracking-tight transition-all hover:underline [&[data-state=open]>svg]:rotate-45',
                    'text-start text-lg'
                  )}
                >
                  {question}
                  <PlusIcon className="h-5 w-5 shrink-0 text-muted-foreground transition-transform duration-200" />
                </AccordionPrimitive.Trigger>
              </AccordionPrimitive.Header>
              <AccordionContent>{answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="flex justify-center mt-4">
          <Button
            variant={'default'}
            className="text-center mt-4 mx-auto "
            onClick={toggleFagLength}
          >
            {showMore ? 'Show less questions' : 'Show more questions'}

            {showMore ? (
              <ArrowUpIcon className="w-4 h-4 ml-2" />
            ) : (
              <ArrowDownIcon className="w-4 h-4 ml-2" />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FAQ07;
